<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        rounded
        text
        small
        :fab="$vuetify.breakpoint.xsOnly"
        v-on="on"
        color="blue-grey"
        dark
      >
        <span v-if="!$vuetify.breakpoint.xsOnly">Email</span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly" small dark
          >mdi-email</v-icon
        >
      </v-btn>
    </template>

    <v-card>
      <ModelTitle title="Send Mail" @close="dialog = false" />

      <v-container grid-list-lg>
        <v-card-text>
          <v-layout row wrap>
            <v-flex>
              <v-text-field
                :error-messages="subjectErrors"
                v-model="subject"
                @focus="$event.target.select()"
                label="Subject"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text>
          <div v-html="viewHtml"></div>
        </v-card-text>
      </v-container>

      <v-divider></v-divider>
      <v-card-actions>
        <small>{{ email }}</small>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="mail()"> Send </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customerService from "@/modules/Customer/service";
import Hashids from "hashids";
const hashids = new Hashids();
const { validationMixin } = require("vuelidate");
const { required, minLength } = require("vuelidate/lib/validators");

export default {
  name: "send-email",
  props: ["email", "type", "id", "name", "postfix", "obj"],
  data() {
    return {
      dialog: false,
      subject: null,
      viewHtml: null,
      url: null,
    };
  },
  computed: {
    subjectErrors() {
      const errors = [];
      if (!this.$v.subject.$dirty) return errors;
      if (!this.$v.subject.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.subject.minLength)
        errors.push("Subject must be at least 10 characters long");
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    subject: {
      required,
      minLength: minLength(10),
    },
  },
  watch: {
    dialog(val) {
      // console.log("val", this.obj);
      if (val) {
        this.subject = `Here is your ${this.type}: ${this.id} from ${this.name}`;
        const hashId = hashids.encode(this.id);

        this.url = `${process.env.VUE_APP_FE_URL}/public/${this.type}/${hashId}/${this.postfix}`;

        const recipientName =
          (this.obj && this.obj.name) ||
          (this.obj && this.obj.Customer && this.obj.Customer.name) ||
          (this.obj && this.obj.Donor && this.obj.Donor.name) ||
          "Customer";

        this.viewHtml = `<html>
              <p>hey, ${recipientName}<p>
              <p>Please click link blow ro view your ${this.type}: ${this.id}.</p>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <td>
                      <table border="0" cellspacing="0" cellpadding="0">
                        <tr>
                          <td>
                            <a href="${this.url}" target="_blank" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; text-decoration: none; border-radius: 3px; background-color: #EB7035; border-top: 12px solid #EB7035; border-bottom: 12px solid #EB7035; border-right: 18px solid #EB7035; border-left: 18px solid #EB7035; display: inline-block;">View ${this.type}</a>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              <p style="margin-top: 10px;">if you can't click on above button, try click on link below or copy and paste into browser</p>
              <p><a href="${this.url}" target="_blank">${this.url}</a></p>
              <p style="margin-top:20px;">Thanks for your business.</p>
              <span style="font-size: 18px;">${this.name}</span>
              <div style="font-size: 12px;">Powered By <a href='https://taleem.com'>taleem.com</a></div>
            </html>`;
      }
    },
  },
  methods: {
    async mail() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        // let data = {
        //   to: this.email,
        //   subject: this.subject,
        //   html: this.viewHtml,
        // };
        await customerService.sendReceipt(this.id).then(() => {
          // console.log('response', response)
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: `Email was send successfully to ${this.email}`,
            });
        });

        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped></style>
